<template>
  <b-modal id="exportpdf" title="Export To PDF" size="md" ok-only ok-title="Close">
    <div v-if="!this.isTrial">
      <p>The PDF export will contain the results of the last search (up to at most 100 results).</p>
      <div class="mt-2">
        <vue-slider
          v-model="numResults"
          :marks="true"
          class="sl mb-3"
          :contained="true"
          v-bind="options"
        ></vue-slider>
      </div>
      <span v-if="note">{{note}}</span>
      <b-button variant="dark" size="md" v-on:click.prevent="generateReport()" class="mt-3">Download</b-button>

    </div>
    <div v-else>
      <p><img src="https://www.sci-fund.ai/wp-content/uploads/2021/05/sci-fund-pdf-export.png" width="300" /></p>
      <p>Export to PDF is not available in the <b>TRIAL</b> version. Want to <a href="https://sci-fund.ai/plans-and-prices" target="_blank">upgrade your account</a>?</p>
    </div>

  </b-modal>
</template>

<script>
export default {
  name: 'ExportToPDF',
  data() {
    return {
      note: '',
      numResults: 20,
      options: {
        min: 0,
        max: 100,
        interval: 10,
      }
    }
  },
  computed: {
    downloadurl () {
      if (this.$store.state.response && this.$store.state.response.base_urls && this.$store.state.response.base_urls && this.$store.state.response.base_urls.search_with_current_state &&
      this.$store.state.response.context &&  this.$store.state.response.context.originalSearchTerms) {
        return this.$store.state.response.base_urls.search_with_current_state.sem_url + "&q=" + encodeURI(this.$store.state.response.context.originalSearchTerms)
      }
      return null;
    },
    isTrial() {
      if (this.$store.state ) {
        return this.$store.state.isTrial;
      }
      return false;
    }
  },
  methods: {
    generateReport () {
      if(this.downloadurl)
        this.$store.dispatch('exportToPDF', { 'searchURL': this.downloadurl, 'numResults': this.numResults });
      else
        this.note='download url not available';
    }
  }

}
</script>
<style scoped>
</style>
